import { useCallback, useState } from 'react'
import { toast } from 'react-toastify'

// AUTH TOKEN START
import jwt_decode from 'jwt-decode'
import { ls, formatter } from 'utils'
import { LSKEY_TOKEN } from 'constants/app'
// AUTH TOKEN END

import { loyaltyAllocationAPI } from 'api/loyalty'
import { MerchantLookupTypes } from 'types/merchanTxTypes'
import {
  LoyaltyAllocationTxFormTypes,
  LoyaltyAllocationTxFormSubmitValuesTypes,
  LoyaltyAllocationTxFormSubmitActionsTypes,
} from 'types/loyaltyAllocationTxTypes'
import { MemberDetail } from 'types/member'
import useMemberStore from 'store/member'

const LOYALTYALLOCATIONTXINITVAL: LoyaltyAllocationTxFormTypes = {
  transactionValue: 0,
  creditValue: 0,
  loyaltyValue: 0,
  externalTransactionId: 0,
  ident: '',
  storeId: 0,
  deviceCode: '',
  cashier: '',
  guid: '',
  transactionDate: '',
  comments: '',
  traceNumber: 0,
  reasonId: 0,
}

export const useLoyaltyAllocationTx = (
  traderId: number,
  onCloseModal: () => void
): {
  member: MemberDetail | undefined
  isLoading: boolean
  initialValues: LoyaltyAllocationTxFormTypes
  isMerchantLookupToggle: boolean
  handleIsMerchantLookupToggle: () => void
  handleSubmitLoyaltyAllocationTx: (
    values: LoyaltyAllocationTxFormSubmitValuesTypes,
    actions: LoyaltyAllocationTxFormSubmitActionsTypes
  ) => void
  handleClearLoyaltyAllocationTx: () => void
} => {
  // AUTH TOKEN START
  const authToken = ls.get(LSKEY_TOKEN)
  const decodeAuthToken: { username: string } = jwt_decode(String(authToken))
  const authTokenUsername = decodeAuthToken?.username || ''
  // AUTH TOKEN END
  // STATES
  const [isMerchantLookupToggle, isMerchantLookupToggleSet] =
    useState<boolean>(false)
  const [isLoading, isLoadingSet] = useState<boolean>(false)
  const [purchaseTxMerchant, purchaseTxMerchantSet] = useState<
    MerchantLookupTypes[]
  >([])
  const member = useMemberStore((state) => state.member)
  const [initialValues, initialValuesSet] =
    useState<LoyaltyAllocationTxFormTypes>({
      ...LOYALTYALLOCATIONTXINITVAL,
      cashier: authTokenUsername,
      externalTransactionId: formatter.externalIdentification(),
      ident: String(member?.cardNumber) || '',
    })

  const handleIsMerchantLookupToggle = useCallback(() => {
    isMerchantLookupToggleSet(!isMerchantLookupToggle)
  }, [isMerchantLookupToggle, isMerchantLookupToggleSet])

  const handleSubmitLoyaltyAllocationTx = useCallback(
    async (
      values: LoyaltyAllocationTxFormSubmitValuesTypes,
      actions: LoyaltyAllocationTxFormSubmitActionsTypes
    ) => {
      isLoadingSet(true)
      try {
        if (String(values.externalTransactionId) === "") {
          values.externalTransactionId = initialValues.externalTransactionId + 1
        }
        await loyaltyAllocationAPI(values)
        toast.success('Loyalty allocation successful.')
        // actions.setSubmitting(false)
        onCloseModal()
      } catch (error) {
        const message = JSON.parse(JSON.stringify(error))
        toast.error(`ERR: ${message.outcomeUserMessage}`)
      }
      isLoadingSet(false)
    },
    [isLoadingSet]
  )

  const handleClearLoyaltyAllocationTx = useCallback(() => {
    initialValuesSet({ ...LOYALTYALLOCATIONTXINITVAL })
    toast.success('Filter successfully cleared.')
  }, [initialValuesSet])

  return {
    member,
    isLoading,
    initialValues,
    isMerchantLookupToggle,
    handleIsMerchantLookupToggle,
    handleSubmitLoyaltyAllocationTx,
    handleClearLoyaltyAllocationTx,
  }
}
